<template>
  <reestr-layout>
    <div class="columns reestr-name-panel">
      <div class="column">
        <div class="container has-text-centered">
          <h1 class="reestr-name">
            Государственная информационная система обеспечения градостроительной
            деятельности
          </h1>
        </div>
      </div>
    </div>
    <div class="columns isogd-section-panel">
      <div class="column">
        <div class="container">
          <fetch-json :url="url">
            <template slot-scope="{ json: gisogdSections, loading }">
              <div
                class="columns is-multiline"
                v-if="!loading && gisogdSections"
              >
                <div
                  class="column is-one-quarter"
                  v-for="gisogdSection in gisogdSections"
                  :key="gisogdSection.id"
                >
                  <GisogdSectionCard
                    :section="gisogdSection"
                    cardClass="isogd-section-card"
                  ></GisogdSectionCard>
                </div>
              </div>
            </template>
          </fetch-json>
        </div>
      </div>
    </div>
  </reestr-layout>
</template>

<script>
import ReestrLayout from "./ReestrLayout";
import GisogdSectionCard from "@/components/documents/GisogdSectionCard";
export default {
  props: {
    projectSchema: { type: String },
  },
  components: {
    ReestrLayout,
    GisogdSectionCard,
  },
  computed: {
    url() {
      return `gisogdsections/${this.projectSchema}`;
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../assets/sass/main.scss";
.reestr-name-panel {
  background-color: $white;
  height: 245px;
}

.reestr-name-panel .reestr-name {
  padding-top: 33px;
  font-size: 26px;
  max-width: 900px;
  margin: 0 auto;
}

.isogd-section-card {
  height: 100%;
}

.isogd-section-panel {
  margin-top: -95px !important;
  position: relative;
  z-index: 100;
}
</style>